import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// E2E Auth Injection: Initialize auth state from window.__INDEEP_E2E_AUTH_STATE__
// when VITE_E2E_AUTH_INJECTION=true (only active during Playwright E2E tests).
// This enables direct profile-completion tests without OTP flow.
import { initializeE2EAuthInjection, isE2EAuthInjectionEnabled } from '@/store/e2eAuthInjection';

// E2E Auth Injection initialization: only runs when VITE_E2E_AUTH_INJECTION='true'.
// This guard cannot be tree-shaken because isE2EAuthInjectionEnabled is called
// in multiple places (module body, useAuthBootstrap, applyE2EAuthInjection).
if (isE2EAuthInjectionEnabled()) {
  initializeE2EAuthInjection();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
